import React from 'react'

const AvatarIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80px"
      height="80px"
      viewBox="0 0 30 30"
      version="1.1"
      {...props}
    >
      <g id="admin-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="bot-icon">
          <rect id="Rectangle" fill="#D8D8D8" opacity="0" x="0" y="0" width="30" height="30" />
          <path
            d="M23.0069695,6.42857143 L6.9930305,6.42857143 C4.90571712,6.42857143 3.21428571,8.11602636 3.21428571,10.1976442 L3.21428571,20.8926221 C3.21428571,22.97424 4.90571712,24.6616949 6.9930305,24.6616949 L9.876707,24.6616949 L9.876707,28.5835632 C9.876707,28.6082645 9.90465577,28.6227325 9.92482134,28.6082645 L15.8283804,24.7047458 L17.3089578,24.6772215 L21.4630652,24.6772215 L23.0069695,24.6616949 C25.0939291,24.6616949 26.7857143,22.97424 26.7857143,20.8926221 L26.7857143,10.1976442 C26.7857143,8.11602636 25.0939291,6.42857143 23.0069695,6.42857143 Z M9.32799123,12.0943549 C9.32799123,11.0526637 10.1745914,10.2078776 11.2193094,10.2078776 C12.2636737,10.2078776 13.1102738,11.0526637 13.1102738,12.0943549 C13.1102738,13.1363989 12.2636737,13.9808321 11.2193094,13.9808321 C10.1745914,13.9808321 9.32799123,13.1363989 9.32799123,12.0943549 Z M14.9127928,21.521095 C12.5152126,21.521095 10.5347414,19.8452849 10.2319041,17.6747422 L19.5940352,17.6747422 C19.2908441,19.8452849 17.3107267,21.521095 14.9127928,21.521095 Z M18.804394,13.9808321 C17.7600297,13.9808321 16.9130758,13.1363989 16.9130758,12.0943549 C16.9130758,11.0526637 17.7600297,10.2078776 18.804394,10.2078776 C19.849112,10.2078776 20.6957122,11.0526637 20.6957122,12.0943549 C20.6957122,13.1363989 19.849112,13.9808321 18.804394,13.9808321 Z"
            id="Shape"
            stroke="#202020"
            fillRule="nonzero"
          />
          <path
            d="M17.1428571,1.60272062 C17.1428571,2.32584299 16.6604667,2.93847546 15.9998487,3.13754244 L15.9998487,4.52298686 L15.0715798,4.52298686 L15.0715798,3.13754244 C14.4109618,2.93847546 13.9285714,2.32584299 13.9285714,1.60272062 C13.9285714,0.719110159 14.6495269,0 15.5357143,0 C16.4219016,0 17.1428571,0.719110159 17.1428571,1.60272062 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
          />
          <path
            d="M0,17.2070539 L0,13.0041449 C0,12.3312492 0.546934799,11.7857143 1.2215573,11.7857143 L2.14285714,11.7857143 L2.14285714,18.4254845 L1.2215573,18.4254845 C0.546934799,18.4251375 0,17.8796026 0,17.2070539 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
          />
          <path
            d="M27.8571429,17.2070539 L27.8571429,13.0041449 C27.8571429,12.3312492 28.4040777,11.7857143 29.0787002,11.7857143 L30,11.7857143 L30,18.4254845 L29.0787002,18.4254845 C28.4040777,18.4251375 27.8571429,17.8796026 27.8571429,17.2070539 Z"
            id="Path-Copy"
            fill="#000000"
            fillRule="nonzero"
            transform="translate(28.9286, 15.1056) scale(-1, 1) translate(-28.9286, -15.1056)"
          />
        </g>
      </g>
    </svg>
  )
}

export default AvatarIcon
